import { render } from "./a-task-spent-time.vue?vue&type=template&id=3056b4a7&scoped=true"
import script from "./a-task-spent-time.vue?vue&type=script&lang=js"
export * from "./a-task-spent-time.vue?vue&type=script&lang=js"

import "./a-task-spent-time.vue?vue&type=style&index=0&id=3056b4a7&lang=sass&scoped=true"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3056b4a7"]])

export default __exports__